import api from "./api";

export function saveSession(token, user) {
  localStorage.setItem("azu_token", token);
  localStorage.setItem("azu_user", JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem("azu_token");
  localStorage.removeItem("azu_user");
}

export function getUser() {
  try {
    const raw = localStorage.getItem("azu_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isLoggedIn() {
  return !!localStorage.getItem("azu_token");
}

export async function login(email, password, otp) {
  const { data } = await api.post("/auth/login", { email, password, otp });
  if (data.token && data.user) {
    saveSession(data.token, data.user);
  }
  return data;
}

export function hasRole(user, ...roles) {
  return user && roles.includes(user.role);
}

export function formatMoney(value) {
  if (value === null || value === undefined) return "—";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
}
